import {
  IToggleLoadingSmartEngage,
  TOGGLE_LOADING_SMART_ENGAGE,
  IUpdateSmartEngageData,
  UPDATE_SMART_ENGAGE,
} from './types';

export function toggleLoadingSmartEngageAction(
  actionData: IToggleLoadingSmartEngage['actionData'],
): IToggleLoadingSmartEngage {
  return {
    type: TOGGLE_LOADING_SMART_ENGAGE,
    actionData,
  };
}

export function updateSmartEngageDataAction(
  actionData: IUpdateSmartEngageData['actionData'],
): IUpdateSmartEngageData {
  return {
    type: UPDATE_SMART_ENGAGE,
    actionData,
  };
}
